import React from 'react';
import { User } from 'lucide-react';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup, { AnimatedSelectionOption } from '../../AnimatedSelectionGroup';

interface GenderSelectionProps {
  gender: 'male' | 'female' | null;
  onChange: (value: 'male' | 'female') => void;
  error?: string;
}

const GENDER_OPTIONS: AnimatedSelectionOption<'male' | 'female'>[] = [
  {
    value: 'male',
    label: 'Male',
    icon: <User className="h-6 w-6" />
  },
  {
    value: 'female',
    label: 'Female',
    icon: <User className="h-6 w-6" />
  }
];

const GenderSelection = ({ gender, onChange, error }: GenderSelectionProps) => {
  return (
    <FormSection
      question="What's your biological sex?"
      helperText="Your biological sex affects countless things in your body, including your hormone levels and overall bodily functions. Knowing your sex helps us provide more accurate recommendations."
      error={error}
    >
      <AnimatedSelectionGroup
        options={GENDER_OPTIONS}
        value={gender}
        onChange={onChange}
        name="gender"
        className="!grid-cols-2"
      />
    </FormSection>
  );
};

export default GenderSelection;
